import { schema } from 'prose-core'
import { StrongNodeType } from 'prose-core'
import { AllSelection, EditorState, NodeSelection, Plugin, TextSelection } from 'prosemirror-state'
import { FormatBarView } from './FormatBarView/FormatBarView'
import { InlineFormatBarPluginKey } from './InlineFormatBarPluginKey'
import { InlineFormatBarPluginInitConfig } from './Types'

const whiteListedNodes = [
  // Text nodes
  schema.nodes.paragraph,
  schema.nodes.heading,
  schema.nodes.check_list,
  schema.nodes.ordered_list,
  schema.nodes.unordered_list,
  schema.nodes.list_item,

  // Nodes with separate format bars
  schema.nodes.table_of_contents,

  schema.nodes.image,
]

const inCodeBlock = (state: EditorState) =>
  state.selection.$from.parent.type === schema.nodes.code_block &&
  state.selection.$to.parent.type === schema.nodes.code_block &&
  state.selection.$from.parent === state.selection.$to.parent

export const shouldShowFormatBar = (state: EditorState) => {
  const isSelectionEmpty = state.selection.empty
  const isAllSelection = state.selection instanceof AllSelection
  const isTextSelection = state.selection instanceof TextSelection
  const isNodeSelection = state.selection instanceof NodeSelection
  const isInCodeBlock = inCodeBlock(state)
  const isSelectingWhitelistedNode =
    isNodeSelection &&
    whiteListedNodes.includes((state.selection as NodeSelection).node.type as StrongNodeType<any, any>)

  return (
    !isSelectionEmpty &&
    ((isTextSelection && !isInCodeBlock) || isAllSelection || (isNodeSelection && isSelectingWhitelistedNode))
  )
}

export const InlineFormatBarPlugin = (config: InlineFormatBarPluginInitConfig): Plugin => {
  return new Plugin({
    key: InlineFormatBarPluginKey,
    state: {
      init: (_, state) => {
        return {
          ...config,
          formatBarVisible: shouldShowFormatBar(state),
          aiSelection: false,
        }
      },
      apply: (tr, pluginState, _oldEditorState, newEditorState) => {
        const { runItemKey } = tr.getMeta(InlineFormatBarPluginKey) || {}

        const formatBarVisible = shouldShowFormatBar(newEditorState)

        return {
          ...pluginState,
          formatBarVisible,
          runItemKey,
        }
      },
    },
    view(editorView) {
      return new FormatBarView(editorView)
    },
  })
}
